import { StocksComponent } from './stocks.component';

export const STOCKS_ROUTES = [
    {
        path: '',
        component: StocksComponent,
        data: {
            role: 'ORGANISME || DECLARATION_STOCK_LECTURE',
            domaines: ['ANPP'],
            menu: {
                libelle: 'menu.stocks',
                icon: 'key'
            }
        }
    },
    {
        path: ':idEntreprise',
        component: StocksComponent,
        data: {
            role: 'ORGANISME || PI || GP',
            domaines: ['ANPP']
        }
    }
];
